import { useEffect } from 'react';
import { ScheduleV2 } from '@frontend/api-schedule-v2';
import { useWaitlistShallowStore } from '../stores/waitlist.store';

export const useSetLocationsWaitlistTotalCount = (locationIds: string[]) => {
  const { setLocationWiseTotalCounts } = useWaitlistShallowStore('setLocationWiseTotalCounts');

  const query = ScheduleV2.Queries.useCountQuery({
    request: { locationIds },
    options: { enabled: locationIds.length > 1 }, // No need to fetch for single location as totalCount is available in infinite query
  });

  useEffect(() => {
    if (!query.isLoading && query.data?.quickfillCount) {
      const totalCounts = query.data.quickfillCount.reduce<Record<string, number>>((acc, curr) => {
        if (curr.locationId) acc[curr.locationId] = curr.count || 0;

        return acc;
      }, {});
      setLocationWiseTotalCounts(totalCounts);
    }
  }, [query.data, query.isLoading, setLocationWiseTotalCounts]);

  return { isLoading: query.isLoading };
};
